import { z } from "zod";

export const EMAIL_TEMPLATE_SUBJECT_MAX = 200;
export const EMAIL_TEMPLATE_BODY_MAX = 20000;

// Both optional (PATCH), but a sent field must not be blank: an empty subject
// used to be stored and then silently replaced by the default on read.
export const updateEmailTemplateSchema = z
  .object({
    subject: z
      .string()
      .trim()
      .min(1, "Predmet emaila ne smije biti prazan.")
      .max(
        EMAIL_TEMPLATE_SUBJECT_MAX,
        `Predmet emaila ne smije biti duži od ${EMAIL_TEMPLATE_SUBJECT_MAX} znakova.`,
      )
      .optional(),
    body: z
      .string()
      .trim()
      .min(1, "Sadržaj emaila ne smije biti prazan.")
      .max(
        EMAIL_TEMPLATE_BODY_MAX,
        `Sadržaj emaila ne smije biti duži od ${EMAIL_TEMPLATE_BODY_MAX} znakova.`,
      )
      .optional(),
  })
  .refine((v) => v.subject !== undefined || v.body !== undefined, {
    message: "Izmijenite predmet ili sadržaj emaila.",
  });
